var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-jm",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 256 256L0 512zm512 0L256 256l256 256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "m0 0 256 256L512 0zm0 512 256-256 256 256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M512 0h-47.7L0 464.3V512h47.7L512 47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M0 0v47.7L464.3 512H512v-47.7L47.7 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJm);
export default __webpack_public_path__ + "static/media/jm.259baa445256a0bc926e973df1505e43.svg";
export { ForwardRef as ReactComponent };